import React from 'react';
import EmailLinkFactory from './emailLink';

const EmailLink = ({ onClick, onMouseEnter, onMouseLeave, link }) => {
    const [isHoveringOnLink, setIsHoveringOnLink] = React.useState(false);

    const handleLinkMouseEnter = () => {
        setIsHoveringOnLink(true);
        onMouseEnter();
    };

    const handleLinkMouseLeave = () => {
        setIsHoveringOnLink(false);
        onMouseLeave(link.hoverActionId);
    };

    return link ? (
        <EmailLinkFactory
            handleLinkClick={onClick}
            handleLinkMouseLeave={handleLinkMouseLeave}
            handleLinkMouseEnter={handleLinkMouseEnter}
            isHoveringOnLink={isHoveringOnLink}
            link={link}
        />
    ) : null;
};

export default EmailLink;
